import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHeartFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M1 5.667C1 2.167 2.167 1 5.667 1h2L8.2 2.333h2.133c3.079 0 4.352.903 4.614 3.501a5 5 0 0 0-.305-.087c-.711-.182-1.535-.247-2.438-.247H3.796c-.903 0-1.727.065-2.438.247q-.18.045-.358.105z"
                fill="currentColor"
            />
            <path
                d="M14.668 8.52c.504.135.967.406 1.332.782.021-1.77-1.094-2.402-3.796-2.402H3.796C.4 6.9-.49 7.9.235 10.899S2.205 15 5.6 15h4.8q.23 0 .447-.007c-.438-.276-.91-.595-1.323-.946-.65-.551-1.526-1.478-1.526-2.761 0-1.411.931-2.493 2.147-2.8a3 3 0 0 1 2.258.337 2.98 2.98 0 0 1 2.265-.303"
                fill="currentColor"
            />
            <path
                d="M9.398 11.285c0-1.5 1.908-2.148 2.999-.591 1.09-1.557 3-.833 3 .591 0 1.214-1.652 2.204-2.892 2.947l-.108.065-.108-.065c-1.24-.743-2.891-1.733-2.891-2.947"
                fill="currentColor"
            />
        </g>
    </svg>
));
FolderHeartFilledSize16Glyph.displayName = 'FolderHeartFilledSize16Glyph';
